import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import DataTable from "react-data-table-component";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import moment from "moment";
import { http } from "../helper";
import { capitalizeFirstLetter } from "../utilityfunctions";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";

const Freeproductspdf = () => {
  const { t } = useTranslation();
  const [searchTextVal, setSearchTextVal] = useState("");
  const [freeproductspdflist, setFreeproductspdflist] = useState([]);
  const [templist, setTemplist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [freeproductpdfvalue, setFreeproductpdfvalue] = useState("");

  useEffect(() => {
    if (!sessionStorage.getItem("isLoggedIn")) {
      window.location.href = "/";
      return;
    }
    const authData = JSON.parse(sessionStorage.getItem("authData"));
    if (
      authData !== "" &&
      !authData.adminRole.permissions.includes("manage_newproducts")
    ) {
      window.location.href = "/unauthorized";
      return;
    }
    getFreeproductpdflist();
  }, []);

  const getFreeproductpdflist = () => {
    const URL = BaseUrl + "admin/listpdf";
    http
      .get(URL)
      .then((response) => {
        setFreeproductspdflist(response.data.data);
        setTemplist(response.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const editfreeproductpdfDetails = (editid) => {
    window.location.href = `/newproducts/edit/${editid}`;
  };

  const deleteFreepdf = (value) => {
    setVisibleAlert(true);
    setFreeproductpdfvalue(value);
  };

  const deletefreeproductspdf = () => {
    const URL = BaseUrl + `admin/deletePDF/${freeproductpdfvalue._id}`;
    http
      .delete(URL)
      .then((response) => {
        if (response.data.success === true) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const alertPopupclose = () => {
    setVisibleAlert(false);
    setFreeproductpdfvalue("");
  };

  const addfreeproduct = () => {
    window.location.href = "/newproducts/add";
  };

  const handleReset = () => {
    setSearchTextVal("");
    setFreeproductspdflist(templist);
  };

  const handleChange = (value) => {
    setSearchTextVal(value);
    filterData(value);
  };

  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue.length > 0) {
      const result = templist.filter((item) =>
        item.PDFTitle.toString().toLowerCase().includes(lowercasedValue),
      );
      setFreeproductspdflist(result);
    } else {
      setFreeproductspdflist(templist);
    }
  };

  const columns = [
    {
      name: t("title_txt"),
      selector: (row) => row.PDFTitle,
      sortable: true,
    },
    {
      name: t("display_on_main_page_txt"),
      selector: (row) => (row.FeaturedPdf ? "Yes" : "No"),
      sortable: true,
    },
    {
      name: t("status_txt"),
      selector: (row) => capitalizeFirstLetter(row.Status),
      sortable: true,
    },
    {
      name: t("sort_order_txt"),
      selector: (row) => row.sortOrder,
      sortable: true,
    },
    {
      name: t("date_created_txt"),
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY HH:mm A"),
      sortable: true,
    },
    {
      name: t("actions_txt"),
      selector: (row) => {
        const canEdit = canAction("manage_newproducts", "edit");
        return (
          <div style={{ display: "flex" }}>
            <a
              className="editbtn button title-tooltip title-up"
              data-title={canEdit ? t("edit_txt") : t("view_txt")}
              style={{ color: "white" }}
              onClick={() => editfreeproductpdfDetails(row._id)}
            >
              <i
                className={`fa ${canEdit ? "fa-pencil" : "fa-eye"}`}
                aria-hidden="true"
              ></i>
            </a>
            {canAction("manage_newproducts", "delete") && (
              <a
                className="editbtn button title-tooltip title-up"
                data-title={t("delete_txt")}
                style={{ color: "white" }}
                onClick={() => deleteFreepdf(row)}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
            )}
          </div>
        );
      },
      sortable: false,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <>
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title">{t("new_products_txt")}</h1>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders">
                  <div className="table-search-reset">
                    <div className="table-search">
                      <input
                        type="text"
                        value={searchTextVal}
                        onChange={(e) => handleChange(e.target.value)}
                        className="form-control"
                        placeholder={t("search_txt")}
                      />
                    </div>
                    <button
                      className="submitbtn button search-ord-btn"
                      onClick={() => filterData(searchTextVal)}
                    >
                      <i className="fa fa-search"></i>
                    </button>
                    <button
                      className="resetbtn"
                      type="reset"
                      onClick={handleReset}
                    >
                      {t("reset_txt")}
                    </button>
                  </div>
                  {canAction("manage_newproducts", "add") && (
                    <div className="add-holidaybtn">
                      <button className="addbtn" onClick={addfreeproduct}>
                        {t("add_txt")}
                      </button>
                    </div>
                  )}
                </div>
                <div className="table_overflow new-prod-data-table">
                  <DataTable
                    columns={columns}
                    noDataComponent={
                      <div className="no-records-found">
                        {t("no_matching_new_products_txt")}
                      </div>
                    }
                    data={freeproductspdflist}
                    customStyles={customStyles}
                    pagination
                    paginationPerPage={25}
                    progressPending={loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={paginationComponentOptions}
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
      {visibleAlert && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("confirm_delete_txt")}</p>
                <div className="alert-buttons">
                  <a
                    title={t("ok_txt")}
                    onClick={deletefreeproductspdf}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    title={t("cancel_txt")}
                    onClick={alertPopupclose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Freeproductspdf;